import type { ParseParams } from 'zod';

export const getI18nErrorMap = (
  translateFn: (error: string) => string,
): ParseParams['errorMap'] => {
  return (_error, ctx) => ({ message: translateFn(ctx.defaultError) });
};
